"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranteeList = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var GranteeItem_1 = require("./GranteeItem");
var GranteeListEmpty_1 = require("./GranteeListEmpty");
var react_intl_1 = require("react-intl");
var utils_1 = require("./utils");
/**
 * @internal
 */
exports.GranteeList = function (props) {
    var grantees = props.grantees, mode = props.mode, onDelete = props.onDelete;
    var intl = react_intl_1.useIntl();
    var sortedGrantees = react_1.useMemo(function () {
        return utils_1.sortGranteeList(grantees, intl);
    }, [grantees, intl]);
    if (grantees.length === 0) {
        return react_1.default.createElement(GranteeListEmpty_1.GranteeListEmpty, null);
    }
    return (react_1.default.createElement("div", { className: "gd-share-dialog-grantee-list" }, sortedGrantees.map(function (grantee) {
        return (react_1.default.createElement(GranteeItem_1.GranteeItemComponent, { key: sdk_model_1.serializeObjRef(grantee.id), grantee: grantee, mode: mode, onDelete: onDelete }));
    })));
};
//# sourceMappingURL=GranteeList.js.map